import { Theme } from "@material-ui/core/styles";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  chartsHeader: {
    margin: "0rem 0px 1.75rem",
  },
  chartsWrapper: {
    margin: "1.5rem 0px 0px",
  },
  chipWrapper: {
    ".MuiChip-root + MuiChip-root": {
      marginLeft: "0.5rem",
    },
  },
  divider: {
    margin: "1.5rem 0px 0px",
  },
  formsWrapper: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.primary.main)}, 0.1)`,
    borderRadius: "4px",
    padding: "1rem",
  },
  inputLabel: {
    height: "1rem",
    transform: "translate(0, -1.5px) scale(0.75)",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/styles.ts